<h1 class="text-center">{{message('outputsHeader')}}</h1>

<form>
  <div class="form-group">
    <div class="dropdown w-75 mx-auto pb-2">
      <label class="sr-only" for="recipeSearchInput" i18n>Recipe Search</label>
      <input #searchBox (input)="onRecipeSearchInput(searchBox.value)"
             [placeholder]="message('recipeSearchPlaceholder')"
             class="dropdown-toggle form-control dark-input" data-toggle="dropdown" id="recipeSearchInput"
             type="search">

      <div aria-labelledby="recipeSearchInput" class="dropdown-menu dark-input">
        <a (click)="onRecipeSelect(recipe)" *ngFor="let recipe of filteredRecipes" class="dropdown-item dark-input"
           href="#">
          <!-- Performance is pretty bad on the recipe list with images.. maybe load 50 at a time or something?
          <img [alt]=recipe.name [ngStyle]="{'background': 'url(' + imageBaseUrl + recipe.primaryOutput.item.imageFile + ') no-repeat',
                'background-position': getItemSpritePosition(recipe.primaryOutput.item),
                'background-size': getItemBackgroundSize(recipe.primaryOutput.item),
                'filter': getItemFilter(recipe.primaryOutput.item)}"
               class="outputSprite mr-2" [src]="imageTemplateUrl">
           -->
          {{recipe.name}}
        </a>
      </div>
    </div>
    <div id="recipes">
      <div *ngFor="let outputDisplay of outputDisplays">
        <div class="row recipeRow mx-auto form-group">
          <app-recipe-modal #recipeModal [recipe]="outputDisplay.subRecipes[0].recipe" [recipeToggleButton]="recipeToggle"
                            [outputDisplay]="outputDisplay">
          </app-recipe-modal>
          <div class="col-8">
            <img [alt]=outputDisplay.itemName [ngStyle]="{'background': 'url(' + getOutputDisplayImageUrl(outputDisplay) + ') no-repeat',
                'background-position': getOutputDisplaySpritePosition(outputDisplay),
                'background-size': getOutputDisplayBackgroundSize(outputDisplay),
                'filter': getOutputDisplayFilter(outputDisplay)}"
                 class="outputSprite mr-2" [src]="imageTemplateUrl">
            <label for="{{outputDisplay.itemNameID}}-itemPriceDisplay">
              <strong>{{outputDisplay.itemName}}</strong>
            </label>
            <span #recipeToggle [ngClass]="{'hidden': outputDisplay.subRecipes.length > 1}"
                  class="material-icons-outlined md-light hoverable recipe-modal-toggle"
                  (click)="toggleModal(recipeModal)">info</span>
          </div>
          <div class="col-3">
            <input [value]="outputDisplay.itemPrice
            .toLocaleString(locale.code,{ maximumFractionDigits: 2, minimumFractionDigits: 0})"
                   class="priceDisplay form-control dark-input read-only"
                   id="{{outputDisplay.itemNameID}}-itemPriceDisplay"
                   readonly type="text">
          </div>
          <div class="col-1">
            <span (click)="onRemoveItem(outputDisplay.itemNameID)"
                  class="material-icons md-light hoverable mt-1">close</span>
          </div>
        </div>
        <ng-template [ngIf]="outputDisplay.subRecipes.length > 1">
          <div *ngFor="let subRecipe of outputDisplay.subRecipes" class="row recipeRow mx-auto form-group">
            <app-recipe-modal #subRecipeModal [recipe]="subRecipe.recipe" [recipeToggleButton]="subRecipeToggle"
            [outputDisplay]="outputDisplay">
            </app-recipe-modal>
            <div class="col-8">
              <label class="pl-6" for="{{subRecipe.recipeNameID}}-itemPriceDisplay">
                {{subRecipe.recipeName}} {{message('recipeSuffix')}}
              </label>
              <span #subRecipeToggle class="material-icons-outlined md-light hoverable recipe-modal-toggle"
                    (click)="toggleModal(subRecipeModal)">info</span>
            </div>
            <div class="col-3">
              <input [value]="subRecipe.recipePrice
                  .toLocaleString(locale.code,{ maximumFractionDigits: 2, minimumFractionDigits: 0})"
                     class="priceDisplay form-control dark-input read-only"
                     id="{{subRecipe.recipeNameID}}-itemPriceDisplay"
                     readonly type="text">
            </div>
            <div class="col-1">
              <span (click)="onRemoveSubRecipe(subRecipe.recipeNameID)" class="material-icons md-light hoverable mt-1">close</span>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</form>
